const Shimmer = () => {
    return (
        <div className="bg-gray-200 w-64 h-92 p-2 m-2 mr-10 hover:cursor-pointer hover:scale-95 overflow-hidden rounded-md">
            <div className="w-60 h-40 border border-solid bg-gray-300"></div>
            <div className="mt-2 w-56 h-7 border border-solid bg-gray-300 rounded-lg"></div>
            <div className="mt-2 w-56 h-7 border border-solid bg-gray-300 rounded-lg"></div>
            <div className="mt-2 w-56 h-7 border border-solid bg-gray-300 rounded-lg"></div>
        </div>
    )
};

export default Shimmer;